// Timer Module

class TimerManager {
  constructor() {
    this.timerSeconds = 90;
    this.timerRemaining = 90;
    this.timerRunning = false;
    this.timerInterval = null;
    this.initialized = false;
  }

  init() {
    if (this.initialized) return;

    // Setup timer preset buttons
    const presetButtons = document.querySelectorAll('.timer-preset-btn');
    presetButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const seconds = parseInt(btn.dataset.seconds);
        if (seconds) {
          this.setTimer(seconds, btn);
        }
      });
    });

    // Setup custom timer input
    const customInput = document.getElementById('customTimerInput');
    const customBtn = document.querySelector('.timer-custom-btn');
    if (customInput && customBtn) {
      customBtn.addEventListener('click', () => this.setCustomTimer());
      customInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          this.setCustomTimer();
        }
      });
    }

    // Setup control buttons
    const playBtn = document.getElementById('timerPlayBtn');
    const resetBtn = document.getElementById('timerResetBtn');

    if (playBtn) {
      playBtn.addEventListener('click', () => this.toggleTimer());
    }
    if (resetBtn) {
      resetBtn.addEventListener('click', () => this.resetTimer());
    }

    this.updateTimerDisplay();
    this.initialized = true;
  }

  setTimer(seconds, buttonElement) {
    this.timerSeconds = seconds;
    this.timerRemaining = seconds;
    this.updateTimerDisplay();

    document.querySelectorAll('.timer-preset-btn').forEach(btn => {
      btn.classList.remove('active');
    });
    if (buttonElement) {
      buttonElement.classList.add('active');
    }

    if (this.timerRunning) {
      this.stopTimer();
    }
  }

  setCustomTimer() {
    const customInput = document.getElementById('customTimerInput');
    if (!customInput) return;

    const customValue = parseInt(customInput.value);
    if (customValue && customValue > 0) {
      this.setTimer(customValue, null);
      document.querySelectorAll('.timer-preset-btn').forEach(btn => {
        btn.classList.remove('active');
      });
    }
  }

  toggleTimer() {
    if (this.timerRunning) {
      this.stopTimer();
    } else {
      this.startTimer();
    }
  }

  startTimer() {
    this.timerRunning = true;
    const playBtn = document.getElementById('timerPlayBtn');
    if (playBtn) {
      playBtn.textContent = '⏸️';
    }

    this.timerInterval = setInterval(() => {
      this.timerRemaining--;
      this.updateTimerDisplay();

      if (this.timerRemaining <= 0) {
        this.stopTimer();
        this.timerComplete();
      }
    }, 1000);
  }

  stopTimer() {
    this.timerRunning = false;
    const playBtn = document.getElementById('timerPlayBtn');
    if (playBtn) {
      playBtn.textContent = '▶️';
    }
    clearInterval(this.timerInterval);
  }

  resetTimer() {
    this.stopTimer();
    this.timerRemaining = this.timerSeconds;
    this.updateTimerDisplay();
  }

  updateTimerDisplay() {
    const display = document.getElementById('timerDisplay');
    if (!display) return;

    const minutes = Math.floor(this.timerRemaining / 60);
    const seconds = this.timerRemaining % 60;
    const displayText = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    display.textContent = displayText;
  }

  timerComplete() {
    // Vibration feedback
    if ('vibrate' in navigator) {
      navigator.vibrate([200, 100, 200]);
    }

    // Audio beep
    try {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      oscillator.frequency.value = 800;
      oscillator.type = 'sine';

      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.5);
    } catch (error) {
      console.log('Audio notification not available:', error);
    }

    // Reset timer to initial value
    this.timerRemaining = this.timerSeconds;
    this.updateTimerDisplay();
  }
}

// Initialize and export
const timerManager = new TimerManager();
timerManager.init();

export { timerManager };
